import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';
import AdvForm from '../../../../CommonComponents/AdvForm';
import { isNumeric } from '../../../../../js/app/react/validators';
import InputDollar from '../../../InputDollar/InputDollarView';

export const validator = amount => () => {
  if (!isNumeric(amount) || +amount < 0) {
    return ['Please specify a valid amount'];
  }
  return [];
};

export const withEmptyStringWhenNull = value => (value === null ? '' : value);

const HomeownersAssociationFeeView = ({
  workflowId,
  branch,
  nullableHomeownersAssociationFee,
  alreadyHadHomeownerAssociationFee,
  hasHomeownersAssociationFee,
  onHomeownersAssociationFeeValueChanged,
}) => (
  <AdvWorkflowStep
    branch={branch}
    workflowId={workflowId}
    canSkip={!hasHomeownersAssociationFee && !alreadyHadHomeownerAssociationFee}
  >
    <Validation
      workflowId={workflowId}
      validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.MonthlyHoa`}
    />

    <h2>What is the expected homeowners association (HOA) fee?</h2>
    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputDollar
            isUnder
            className="md"
            placeholder="Monthly HOA"
            placeholderClassName="adv-workflows-placeholder-large"
            value={withEmptyStringWhenNull(nullableHomeownersAssociationFee)}
            onChange={onHomeownersAssociationFeeValueChanged(workflowId)}
            id="adv-monthly-hoa"
          />
        </li>
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={validator(nullableHomeownersAssociationFee)}
      validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.MonthlyHoa`}
      workflowId={workflowId}
      backendKey={HOME_PURCHASE_GOAL_GRAPH_NODE}
    />
  </AdvWorkflowStep>
);

HomeownersAssociationFeeView.defaultProps = {
  nullableHomeownersAssociationFee: null,
};

HomeownersAssociationFeeView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  homePurchaseGoal: PropTypes.shape({}).isRequired,
  setHomePurchaseGoal: PropTypes.shape({}).isRequired,
  hasHomeownersAssociationFee: PropTypes.bool.isRequired,
  alreadyHadHomeownerAssociationFee: PropTypes.bool.isRequired,
  nullableHomeownersAssociationFee: PropTypes.string,
  onHomeownersAssociationFeeValueChanged: PropTypes.func.isRequired,
};

export default HomeownersAssociationFeeView;
